import { FC } from 'react';
import cn from 'classnames';

interface LayerTileProps {
  id: string;
  src?: string;
  label?: string;
  isActive?: boolean;
  onClick?: (id: string) => void;
}

export const LayerTile: FC<LayerTileProps> = ({
  id,
  src,
  label,
  isActive,
  onClick,
}) => (
  <div
    role="button"
    className="flex flex-col gap-1 w-full h-full rounded-[10px] cursor-pointer"
    onClick={() => onClick?.(id)}
  >
    <img
      src={src}
      className={cn(
        'aspect-[1.5] rounded-[inherit] bg-bright',
        isActive && 'outline outline-2 outline-bright_product'
      )}
    />
    {label && <div className="tpg-c1 text-center">{label}</div>}
  </div>
);
